import { standardApiHandler } from "../../../core/core-api/apiTools";
import { getCapabilitiesAdapter } from "./getCapabilities.adapter";
import { WfsCapabilities } from "./types";

export type GetCapabilitiesServiceParams = {};
export type GetCapabilitiesServiceResponse = WfsCapabilities;

export type GetCapabilitiesService = (params: GetCapabilitiesServiceParams) => Promise<GetCapabilitiesServiceResponse>;
export const getCapabilitiesService: GetCapabilitiesService = standardApiHandler(getCapabilitiesAdapter);
